import React from 'react';
import './Page.css';

const CookiePolicy = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h1>Cookies Policy</h1>
        
        <p>This Notice is issued by QuantumSync s.r.o. C 388554 ("quantumsync.tech", "we", "us" and "our").</p>
        
        <h2>Websites to Which This Notice Applies</h2>
        <p>This notice applies to the quantumsync.tech website available at quantumsync.tech (the "site"):</p>
        
        <h2>What Are Cookies?</h2>
        <p>Cookies are small text files that may be stored on your computer or other device when you visit a website. They are generally used to enable websites to function, keep track of your movements within the website, remember your login details, and more.</p>
        
        <p>There are different types of cookies, distinguished by their origin, function, and lifespan. Important characteristics of cookies include:</p>
        
        <div className="info-cards">
          <div className="info-card">
            <h3>First-party cookies</h3>
            <p>Placed by the website you are visiting.</p>
          </div>
          
          <div className="info-card">
            <h3>Third-party cookies</h3>
            <p>Placed by a website other than the one you are visiting.</p>
          </div>
          
          <div className="info-card">
            <h3>Necessary cookies</h3>
            <p>Essential for the technical operation of a website.</p>
          </div>
          
          <div className="info-card">
            <h3>Performance cookies</h3>
            <p>Collect data on website performance.</p>
          </div>
          
          <div className="info-card">
            <h3>Functionality cookies</h3>
            <p>Enhance usability by remembering your preferences.</p>
          </div>
          
          <div className="info-card">
            <h3>Targeting/advertising cookies</h3>
            <p>Enable personalized advertising.</p>
          </div>
        </div>
        
        <h2>How We Use Cookies</h2>
        <p>We use cookies to:</p>
        <ul>
          <li>Provide services to you</li>
          <li>Execute your orders and requests</li>
          <li>Tailor our site and products to your needs and preferences</li>
          <li>Analyze how our site is used and compile anonymous, aggregate statistics</li>
        </ul>
      </div>
    </div>
  );
};

export default CookiePolicy;
